import { render } from "./EquipementImpaye.vue?vue&type=template&id=388ec8a2"
import script from "./EquipementImpaye.vue?vue&type=script&lang=js"
export * from "./EquipementImpaye.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__